module.exports = __webpack_public_path__ + "static/media/Justact-mailers-expert-01.83cc4a5a.png";